import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { VendorInvoicesLineItem} from './endpoints';

@Injectable({
    'providedIn': 'root'
})
export class VendorInvoiceLineItemService extends BaseService {
    constructor(http: HttpClient) {
        super(http);
    }
    
    delete(id: any): Observable<any> {        
        const url = VendorInvoicesLineItem + "/" + id;
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*'
            }
        };
        return this.deleteRequest(url, options);
    }

    create(VendorInvoicesId: any, data): Observable<any> {
        const url = VendorInvoicesLineItem + "?vendor_invoice_id=" + VendorInvoicesId;
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*'
            }
        };
        return this.postRequest(url, data, options);
    }

    getItems(VendorInvoicesParams: any): Observable<any> {
        const url = VendorInvoicesLineItem + '?' + this.makeQueryString(VendorInvoicesParams);
        return this.getRequest(url, null);
    }

    getVendorInvoiceLineItemById(VendorInvoicesId: any): Observable<any> {
        const url = VendorInvoicesLineItem + VendorInvoicesId;        
        return this.getRequest(url, null);
    }

    update(VendorInvoicesId: number, updateParams: any): Observable<any> {
        const url = VendorInvoicesLineItem + VendorInvoicesId;
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*'
            }
        };
        return this.putRequest(url, updateParams, options);
    }
}
